var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-111 -14087)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Rectangle_6_copy_3",
    "data-name": "Rectangle 6 copy 3",
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(111 14087)",
    fill: "#fff",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    id: "Triangle_1",
    "data-name": "Triangle 1",
    d: "M152.533,14120.434l-12.187,6.985v-13.97Z",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogo);
export default __webpack_public_path__ + "static/media/youtube-logo.96a7169b521751d9fe1cc68a3d4ffa8a.svg";
export { ForwardRef as ReactComponent };